'use strict';

const keyMirror = require('keymirror');

/**
 * Retrieve value from local session data from given key.
 * @param {String} key
 * @return {Object}
 */
function _getSession(key) {
    if (sessionStorage.getItem(key) && sessionStorage.getItem(key) !== 'undefined') {
        return JSON.parse(sessionStorage.getItem(key));
    } else {
        return '';
    }
}

function _isPaidVersion() {
    return _getSession('cache_applicant_license') === 'FULL_VERSION' || _getSession('cache_applicant_license') === 'FREE_VERSION' ;
}


module.exports = {

    ActionTypes: keyMirror({

        // Header actions
        CLICK_SHOW_SIDEBAR: null,

        // Session Actions
        LOGGED_IN: null,
        LOGGED_OUT: null,

        // Chronologyc actions
        OPEN_DAY_NOTES: null,
        CLOSE_DAY_NOTES: null,
        NOTE_ADDED: null,
        NOTE_CHANGED: null,
        NOTE_REMOVED: null,
        BREWING_NOTE_NEED_FETCH: null,
        PACKAGING_NOTE_NEED_FETCH: null,

        // Dashboard Actions
        CONTEXT_MENU_ADD_DAY_ORDER_ABOVE: null,
        CONTEXT_MENU_ADD_DAY_ORDER_BELOW: null,
        CONTEXT_MENU_MOVE_DAY_ORDER_BEFORE: null,
        CONTEXT_MENU_MOVE_DAY_ORDER_AFTER: null,
        CONTEXT_MENU_NEW_ORDER_DASHBOARD: null,
        CONTEXT_MENU_REMOVE_DAY_ORDER: null,
        CONTEXT_MENU_REMOVE_ORDER: null,
        CONTEXT_MENU_CHANGE_ORDER_DASHBOARD: null,
        CONTEXT_MENU_CHANGE_TASK_ORDER_DASHBOARD: null,
        FORCE_CLEAN_ORDER_SELECTED_DASHBOARD: null,

        FORCE_MANUAL_DRAWING_DASHBOARD: null,
        FORCE_MANUAL_RE_FETCH_AND_DRAWING_DASHBOARD: null,
        RIGHT_CLICK_DASHBOARD: null,
        LEFT_SINGLE_CLICK_DASHBOARD_EMPTY: null,
        LEFT_DOUBLE_CLICK_DASHBOARD_EMPTY: null,
        LEFT_DOUBLE_CLICK_DASHBOARD_OCCUPIED: null,
        RIGHT_DOUBLE_CLICK_DASHBOARD_EMPTY: null,
        RIGHT_DOUBLE_CLICK_DASHBOARD_OCCUPIED: null,
        RIGHT_DOUBLE_CLICK_DASHBOARD_OCCUPIED_BREWHOUSE: null,

        NEW_ORDER: null,
        CHANGE_ORDER: null,
        REMOVED_ORDER: null,

        // when add new operation draft from user which is not saved in server side yet
        NEW_ORDER_DRAFT: null,
        CHANGE_ORDER_DRAFT: null,
        REMOVED_ORDER_DRAFT: null,

        SHOW_LOADING: null,
        HIDE_LOADING: null,

        // Operation which happens from polling mechanism
        SAVE_DRAFT: null,
        SAVE_DRAFT_SUCCESS: null,
        SAVE_DRAFT_FAILURE: null,
        
        // User Dashboard Tasks
        FETCH_SCHEDULE_BOARD: null,
        FETCH_SCHEDULE_BOARD_SUCCESS: null,
        FETCH_SCHEDULE_BOARD_FAILURE: null,
    
        SAVING_SCHEDULE_BOARD: null,
        SAVING_SCHEDULE_BOARD_SUCCESS: null,
        SAVING_SCHEDULE_BOARD_FAILURE: null,
        
        ADDING_NOTE_SCHEDULE_BOARD: null,
        ADDING_NOTE_SCHEDULE_BOARD_SUCCESS: null,
        ADDING_NOTE_SCHEDULE_BOARD_FAILURE: null,
    
        DELETING_SCHEDULE_BOARD: null,
        DELETING_SCHEDULE_BOARD_SUCCESS: null,
        DELETING_SCHEDULE_BOARD_FAILURE: null,
    
        DELETING_USER_TASK: null,
        DELETING_USER_TASK_SUCCESS: null,
        DELETING_USER_TASK_FAILURE: null,
    
        // Operation which came from an admin user
        PUBLISHING_CHANGE_ADMIN_DRAFT: null,

        // Operation which came from user on dashboard when an admin want to pushish
        // draft operations.
        PUBLISHING_DRAFT: null,
        PUBLISHING_DRAFT_SUCCESS: null,
        PUBLISHING_DRAFT_FAILURE: null,
        UNDO_DRAFT: null,
        UNDO_DRAFT_SUCCESS: null,
        UNDO_DRAFT_FAILURE: null,
        REDO_DRAFT: null,
        REDO_DRAFT_SUCCESS: null,
        REDO_DRAFT_FAILURE: null,

        // when one batch of orders are already perform
        PERFORM_BATCH_OPERATION_END: null,

        FINISH_TO_DRAGGING_OR_RESIZING: null,

        // Tank admin actions
        ADDED_TANK: null,
        CHANGED_TANK: null,
        DELETED_TANK: null,

        // Dashboard modal actions
        DASHBOARD_MODAL_OPEN_NEW_ORDER: null,
        DASHBOARD_MODAL_OPEN_EXISTING_ORDER: null,
        DASHBOARD_MODAL_CHANGE_NUMBER: null,
        DASHBOARD_MODAL_CHANGE_BEER_STYLE: null,
        DASHBOARD_MODAL_CHANGE_PRODUCT_AMOUNT: null,
        DASHBOARD_MODAL_CHANGE_TASK_TYPE: null,
        DASHBOARD_MODAL_CHANGE_TOGGLE: null,
        DASHBOARD_MODAL_CHANGE_VOLUME: null, // the same to Combined and Single
        DASHBOARD_MODAL_CLOSE_MODAL: null,
        DASHBOARD_SWITCH_CLOSE_MODAL: null,

        DASHBOARD_MODAL_BREW_CHANGE_BREW_DATE: null,
        DASHBOARD_MODAL_BREW_CHANGE_FILTRATION: null,
        DASHBOARD_MODAL_BREW_CHANGE_PACKAGING: null,

        DASHBOARD_MODAL_SINGLE_CHANGE_FROM_DATE: null,
        DASHBOARD_MODAL_SINGLE_CHANGE_TO_DATE: null,

        // App actions
        NEW_VERSION_API: null,

        PERMISSION_REQUEST_UPDATE: null,
        PERMISSION_UPDATED: null,

        SAVE_CONFIGURATION_SETTINGS: null
    }),

    Permissions: {
        ADMIN_TANK: 'Tanks/sections',
        ADMIN_BEER_STYLE: 'Beer styles',
        ADMIN_TASK: 'Tasks/QC',
        ADMIN_ICON: 'Icons in sections',
        ADMIN_ITEM: 'Items',
        ADMIN_PURCHASE_ITEM: 'Purchase items',
        ADMIN_CUSTOMER: 'Customers',
        ADMIN_INVENTORY_AND_TRANSFERS: 'Inventory and transfers',
        ADMIN_PRODUCT: 'Products',
        ADMIN_LOCATION: 'Locations',
        ADMIN_VENDOR: 'Suppliers',
        ADMIN_SALE: 'Sales',
        ADMIN_USER: 'Users',
        ADMIN_USER_ACCESS: 'User access',
        ADMIN_PURCHASE: 'Purchase items (PO)',
        DASHBOARD: 'Dashboard pop-up window',
        ADMIN_USER_PERMISSION: 'User Access',
        ADMIN_BEER_STYLE_CONFIGURATION: 'Beer styles- Icon configuration',
        ADMIN_REPORT: 'Reports'
    },
    // Analytics constants
    Analytics: {
        categories: keyMirror({
            ADVERTISEMENT_BANNER_CLICK: null,
            ADVERTISEMENT_BANNER_CLICK_ARROW: null,
            ORDER: null,
            ORDER_SINGLE: null,
            DASHBOARD: null,
            NOTES: null,
            TANKS: null,
            STYLE_BEER: null,
            APPLICATION: null
        }),
        actions: keyMirror({
            CLICK: null,
            NEW: null,
            CHANGE: null,
            DELETE: null,
            NAVIGATE: null,
            SIGN_IN: null,
            SIGN_UP: null,
            SIGN_OUT: null,
            A_LIVE: null
        }),
        labels: {
            ORDER_DRAG_AND_DROP: 'Order changed - Drag and Drop',
            ADVERTISEMENT_BANNER_CLICK: 'Banner clicked',
            ORDER_RESIZED: 'Order changed - Vertical re-sized',
            NOTES_BREWING: 'Notes changed - Brewing side',
            NOTES_PACKAGING: 'Notes changed - Packaging side',
            NOTES_PACKAGING_OPEN: 'Notes open - Packaging side',
            NOTES_PACKAGING_CLOSE: 'Notes close - Packaging side',
            NOTES_BREWING_OPEN: 'Notes open - Brewing side',
            NOTES_BREWING_CLOSE: 'Notes close - Brewing side',
            DASHBOARD_SELECT_ROW_DAY_BAR: 'Dashboard - Select day row bar'
        }
    },

    // CACHE
    KEY_CUSTOM_ICONS: 'cache_custom_icons',
    KEY_PRODUCT_ICONS: 'cache_product_icons',
    KEY_PRODUCT_ITEMS: 'cache_product_items',
    KEY_LOCATION_ITEMS: 'cache_location_items',
    KEY_PRODUCTS: 'cache_products',
    KEY_TANK: 'cache_tanks',
    KEY_BREW_PROCESS: 'cache_brew_process',
    KEY_FERMENTING_PROCESS: 'cache_fermenting_process',
    KEY_PACKAGING_PROCESS: 'cache_packaging_process',
    KEY_ITEMS: 'cache_items',
    KEY_LOCATION: 'cache_current_locator',
    KEY_VENDOR_PURCHASE_ITEMS: 'cache_vendor_purchase_items',
    KEY_VENDOR_ITEMS: 'cache_vendor_items',
    KEY_BEER_STYLE_TASK_CONFIGURATIONS: 'cache_beerstyle_task_configurations',

    // Custom header tags
    APPLICANT_ID_CUSTOM_HEADER: 'X-Applicant-Id',
    TOKEN_AUTH_CUSTOM_HEADER: 'X-AUTH-TOKEN',
    LOCALE_CUSTOM_HEADER: 'X-Locale',
    COUNTRY_CODE_CUSTOM_HEADER: 'X-Country-Code',
    CURRENCY_CODE_CUSTOM_HEADER: 'X-Currency-Code',

    // MODULES ACRONYM
    MODULE_ITEM_ACRONYM: 'IT', //  item
    MODULE_PRODUCT_ACRONYM: 'PR', //  products

    // THE AMOUNT OF ITEMS WHICH SHOWS EACH TABLE ITEMS
    MAX_ITEMS_BY_PAGES_ADMINS: 12,
    MAX_VISIBLE_BUTTON_PAGES: 3,

    // TYPE OF TANKS
    TYPE_TANKS: ['BH', 'FV', 'BT'],
    FERMENTING_SECTION_NAME: 'Fermenting',
    PACKAGING_SECTION_NAME: 'Packaging',
    BREWING_SECTION_NAME: 'Brewing',
    TYPE_TANKS_WITH_SECTIONS: [{type: 'BH', section: 'Brewing'}, {type: 'FV', section: 'Fermenting'}, {
        type: 'BT',
        section: 'Packaging'
    }],
    TANKS_SECTIONS: ['Brewing', 'Fermenting', 'Packaging'],
    getSections: (t, customField = 'section') => {
        return [
            {[customField]: 'Brewing', displayText: t('brewing')},
            {[customField]: 'Fermenting', displayText: t('fermenting')},
            {[customField]: 'Packaging', displayText: t('packaging')}
        ];
    },
    getSectionsMapping: (t) => {
        return {
            ['Brewing']: t('brewing'),
            ['Fermenting']: t('fermenting'),
            ['Packaging']: t('packaging')
        };
    },
    getIconsMapping: (t) => {
        return {
              ['brewing']: t('brewing'),
              ['filtration']: t('filtration'),
              ['packaging']: t('packaging'),
              ['Bottle']: t('dashboard_service_cache_name_bottle'),
              ['Fruit']: t('dashboard_service_cache_name_fruit'),
              ['Pumpkin']: t('dashboard_service_cache_name_pumpkin'),
              ['Honey']: t('dashboard_service_cache_name_honey'),
              ['Coffee Bean']: t('dashboard_service_cache_name_coffee_bean'),
              ['Cooling']: t('dashboard_service_cache_name_cooling'),
              ['Temperature']: t('dashboard_service_cache_name_temperature'),
              ['Firkin']: t('dashboard_service_firkin'),
              ['Keg']: t('dashboard_service_cache_keg'),
              ['Wood Barrel']: t('dashboard_service_cache_name_wood_barrel'),
              ['Tote']: t('dashboard_service_cache_name_tote'),
              ['Repair']: t('dashboard_service_cache_name_repair'),
              ['Report Problem']: t('dashboard_service_cache_name_report_problem'),
              ['Class or meeting']: t('dashboard_service_cache_name_class_or_meeting'),
              ['class_meeting']: t('dashboard_service_cache_name_class_or_meeting'),
              ['Note']: t('dashboard_service_cache_name_note'),
              ['Cleaning']: t('dashboard_service_cache_name_cleaning'),
              ['Transfer']: t('dashboard_service_cache_name_transfer'),
              ['Centrifuge']: t('dashboard_service_cache_name_centrifuge'),
              ['Column still']: t('dashboard_service_cache_name_column_still'),
              ['Pot still']: t('dashboard_service_cache_name_pot_still'),
              ['Brew & yeast']: t('dashboard_service_cache_brew_yeast'),
              ['Brew & Flask']: t('dashboard_service_cache_name_brew_flask'),
              ['Filter and Brew']: t('dashboard_service_cache_name_filter_brew'),
              ['Brew Day Before']: t('dashboard_service_cache_name_brew_day_before'),
              ['Can']: t('dashboard_service_cache_name_can'),
              ['Box']: t('dashboard_service_cache_name_box'),
              ['Bottle & keg']: t('dashboard_service_cache_name_bottle_keg'),
              ['Can & Keg']: t('dashboard_service_cache_name_can_keg'),
              ['Can & Bottle']: t('dashboard_service_cache_name_can_bottle'),
              ['Can, Bottle & Keg']: t('dashboard_service_cache_name_can_bottle_keg'),
              ['Can & Box']: t('dashboard_service_cache_name_can_box'),
              ['Bottle Pack']: t('dashboard_service_cache_name_bottle_pack'),
              ['No Pack']: t('dashboard_service_cache_name_no_pack'),
              ['Mix Box']: t('dashboard_service_cache_name_mix_box'),
              ['Co2']: t('dashboard_service_cache_name_co2'),
              ['Receiving Truck']: t('dashboard_service_cache_name_receiving_truck'),
              ['Shipping Truck']: t('dashboard_service_cache_name_shipping_truck'),
              ['Brew & CIP']: t('dashboard_service_cache_name_brew_cip'),
              ['Brew & O2']: t('dashboard_service_cache_name_brew_o2'),
              ['Brew, CIP & O2']: t('dashboard_service_cache_name_brew_cip_o2'),
              ['Yeast Drain']: t('dashboard_service_cache_name_yeast_drain'),
              ['Yeast From']: t('dashboard_service_cache_name_yeast_from'),
              ['Yeast Harvest']: t('dashboard_service_cache_name_yeast_harvest'),
              ['Yeast In From']: t('dashboard_service_cache_name_yeast_in_from'),
              ['Yeast In']: t('dashboard_service_cache_name_yeast_in_from'),
              ['Yeast New Pitch']: t('dashboard_service_cache_name_yeast_new_pitch'),
              ['Yeast Out']: t('dashboard_service_cache_name_yeast_out'),
              ['Fining or Enzymes']: t('dashboard_service_fining_or_enzymes'),
              ['no-icon']: t('dashboard_service_cache_name_no_icon'),
              ['Dry Hopping']: t('dashboard_service_cache_name_dry_hopping'),
              ['Dy and DH']: t('dashboard_service_cache_name_dy_and_dh'),
              ['DY and DH']: t('dashboard_service_cache_name_dy_and_dh')
        };
    },
    getProductCategoryMapping: (t) => {
        return {
            ['FINISHED']: t('finished'),
            ['SEMI-FINISHED']: t('semi_finished'),
            ['IN PROGRESS']: t('in_progress')
        };
    },
    getCategoryMapping: (t) => {
        return {
            ['Grains']: t('grain'),
            ['Hops']: t('hops'),
            ['Yeast']: t('yeast'),
            ['Additives']: t('additives'),
            ['Chemicals']: t('chemicals'),
            ['Packaging']: t('packaging'),
            ['FINISHED']: t('finished'),
            ['SEMI-FINISHED']: t('semi_finished'),
            ['Others']: t('others')
        };
    },
    ITEM_CATEGORY_NON_INVENTORY: 'NON-INVENTORY',
    ITEM_CATEGORY: ['Grains', 'Hops', 'Yeast', 'Additives', 'Chemicals', 'Packaging', 'FINISHED', 'SEMI-FINISHED', 'Others'],
    PRODUCT_CATEGORY: ['FINISHED', 'SEMI-FINISHED', 'IN PROGRESS'],
    ITEM_SALEABLE_CATEGORY: ['FINISHED', 'SEMI-FINISHED', 'SALES-MARKETING'],

    // SALES
    SALE_STATE: ['OPEN', 'OPEN_PENDING', 'NOTIFIED', 'CONFIRM_NOTIFIED', 'DELIVERED', 'DELIVERED_PAID'],
    SALE_PRIORITIES: ['LOW', 'MEDIUM', 'HIGH', 'IMMEDIATELY'],
    getSalesPriorities(t) {
      return [
          {priority: 'LOW', displayText: t('sales_priority_state_low')},
          {priority: 'MEDIUM', displayText: t('sales_priority_state_medium')},
          {priority: 'HIGH', displayText: t('sales_priority_state_high')},
          {priority: 'IMMEDIATELY', displayText: t('sales_priority_state_immediately')}
      ];
    },
    getSalesStateMapping(t) {
      return {
          LOW: t('sales_priority_state_low'),
          MEDIUM: t('sales_priority_state_medium'),
          HIGH: t('sales_priority_state_high'),
          IMMEDIATELY: t('sales_priority_state_immediately'),
          OPEN: t('sales_state_open'),
          OPEN_PENDING: t('sales_state_open_pending'),
          REOPEN_PENDING: t('sales_state_re_open_pending'),
          NOTIFIED: t('sales_state_notified'),
          CONFIRM_NOTIFIED: t('sales_state_confirm_notified'),
          DELIVERED: t('sales_state_delivered'),
          DELIVERED_PAID: t('sales_state_delivered_paid'),
          VIRTUAL_ITEM_CATEGORY: t('sales_state_virtual_item_category')
      };
    },
    SALE_STATE_OPEN: 'OPEN',
    SALE_STATE_OPEN_PENDING: 'OPEN_PENDING',
    SALE_STATE_REOPEN_PENDING: 'REOPEN_PENDING',
    SALE_STATE_NOTIFIED: 'NOTIFIED',
    SALE_STATE_CONFIRM_NOTIFIED: 'CONFIRM_NOTIFIED',
    SALE_SATES_NOTIFIED: ['CONFIRM_NOTIFIED','NOTIFIED'],
    SALE_STATE_DELIVERED: ['DELIVERED', 'DELIVERED_PAID'],
    SALE_VIRTUAL_ITEM_CATEGORY: 'VIRTUAL_ITEM_CATEGORY',

    // SALES ITEMS
    SALE_ITEM_NOTIFIED: 'NOTIFIED',
    SALE_ITEM_NON_NOTIFIED: 'NON_NOTIFIED',

    PRODUCT_CATEGORY_CONSUME_VOLUME: ['FINISHED', 'SEMI-FINISHED'],
    TYPE_TANK_FERMENTER: 'FV',
    TYPE_TANK_BRITE_TANK: 'BT',
    TYPE_TANK_BREW_HOUSE: 'BH',
    DEFAULT_TANK_UNIT: 'v',

    APP_MODULES: [
        {name: 'DASHBOARD_ORDERS', displayName: 'Dashboard'},
        {name: 'ADMIN_ICON', displayName: 'Icons', isDisabled: true},
        {name: 'ADMIN_ITEM', displayName: 'Items'},
        {name: 'ADMIN_PROCESS', displayName: 'Process'},
        {name: 'ADMIN_PRODUCT', displayName: 'Products'},
        {name: 'ADMIN_PRODUCT_ITEM', displayName: 'Product items'},
        {name: 'ADMIN_PRODUCT_ICON', displayName: 'Product icons', isDisabled: true},
        {name: 'ADMIN_TANK', displayName: 'Tanks'},
        {name: 'ADMIN_BEER_STYLE', displayName: 'Beer style'},
        {name: 'ADMIN_BEER_STYLE_CONFIGURATION', displayName: 'Config beer style'},
        {name: 'ADMIN_LOCATION', displayName: 'Locations'},
        {name: 'ADMIN_LOCATION_ITEM', displayName: 'Locations Items'},
        {name: 'ADMIN_VENDORS', displayName: 'Vendors'},
        {name: 'ADMIN_VENDORS_ADDRESS', displayName: 'Vendor address'},
        {name: 'ADMIN_VENDORS_CONTACTS', displayName: 'Vendor contacts'},
        {name: 'ADMIN_VENDORS_ITEM', displayName: 'Vendor items'}
    ],

    // Dashboard state togglers
    TOGGLE_BT: 'TOGGLE_BT',
    TOGGLE_FV: 'TOGGLE_FV',
    TOGGLE_FV_BT: 'TOGGLE_FV_BT',
    TOGGLE_BH: 'TOGGLE_BH',
    TOGGLE_BH_BH: 'TOGGLE_BH_BH',
    TOGGLE_BH_FV: 'TOGGLE_BH_FV',
    TOGGLE_BH_BT: 'TOGGLE_BH_BT',
    TOGGLE_BH_FV_BT: 'TOGGLE_BH_FV_BT',
    TOGGLE_BH_FV_BH: 'TOGGLE_BH_FV_BH',
    TOGGLE_BH_BT_BH: 'TOGGLE_BH_BT_BH',
    TOGGLE_BH_FV_FV: 'TOGGLE_BH_FV_FV',
    TOGGLE_BH_BT_BT: 'TOGGLE_BH_BT_BT',

    CONTACTS_TYPE: ['PHONE', 'EMAIL'],
    getContactMapping(t) {
      return {
          PHONE: t('phone'),
          EMAIL: t('email')
      };
    },
    getContacts(t) {
        return [
            {type: 'PHONE', displayText: t('phone')},
            {type: 'EMAIL', displayText: t('email')}
        ];
    },

    // LICENSES
    LICENSE_FULL_VERSION:'FULL_VERSION',
    LICENSE_TRIAL_FULL_VERSION:'TRIAL_FULL_VERSION',
    LICENSE_FREE_VERSION:'FREE_VERSION',

    /**
     * The entire purchase order is close when all of their purchase items
     * are received or rejected.
     */
    PURCHASES_STATES: [
        'OPEN',
        'OPEN_PENDING',
        'OPEN_ORDERED',
        'OPEN_ORDERED_LATE',
        'RECEIVED',
        'ORDER_PARTIALLY_RECEIVED',
        'RECEIVED_WITH_ISSUE',
        'CLOSED_COMPLETE',
        'CLOSED_RESOLVED'
    ],
    getPurchaseStateMapping(t) {
      return {
          'OPEN': t('purchase_state_open'),
          'OPEN_PENDING': t('purchase_state_open_pending'),
          'OPEN_ORDERED': t('purchase_state_open_ordered'),
          'OPEN_ORDERED_LATE': t('purchase_state_open_ordered_late'),
          'RECEIVED': t('purchase_state_received'),
          'ORDER_PARTIALLY_RECEIVED': t('purchase_state_partially_received'),
          'RECEIVED_WITH_ISSUE': t('purchase_state_received_with_issue'),
          'CLOSED_COMPLETE': t('purchase_state_closed_complete'),
          'CLOSED_COMPLETE_PAID': t('purchase_state_closed_complete_paid'),
          'CLOSED_RESOLVED': t('purchase_state_closed_resolved'),
          'CLOSED_RESOLVED_PAID': t('purchase_state_closed_resolved_paid'),
          'PENDING': t('purchase_state_pending'),
          'ORDERED': t('purchase_state_ordered'),
          'NO_MORE_ON_THE_WAY': t('purchase_state_no_more_on_the_way'),
          'MORE_ON_THE_WAY': t('purchase_state_more_on_the_way'),
          'REJECT_REMAINDER': t('purchase_state_reject_remainder')
      };
    },
    PURCHASE_STATES_REMOVABLE: [
        'OPEN',
        'OPEN_PENDING',
        'OPEN_ORDERED',
        'OPEN_ORDERED_LATE'
    ],

    PURCHASE_STATE_DASHBOARD_COUNT_AS_ORDERED: [
        'ORDERED',
        'MORE_ON_THE_WAY'
    ],

    PURCHASES_STATES_ITEMS: [
        'PENDING',
        'ORDERED'
    ],

    getReceiveStatesMapping(t) {
      return {
          ['NO_MORE_ON_THE_WAY']: t('purchase_receive_state_no_more_on_the_way'),
          ['MORE_ON_THE_WAY']: t('purchase_receive_state_more_on_the_way'),
          ['REJECT_REMAINDER']: t('purchase_receive_state_reject_reminder')
      };
    },
    
    ONLY_NO_MORE_ON_THE_WAY: [
        'NO_MORE_ON_THE_WAY'
    ],
    
    RECEIVE_STATES_ITEMS: [
        'NO_MORE_ON_THE_WAY',
        'MORE_ON_THE_WAY',
        'REJECT_REMAINDER'
    ],

    PURCHASE_RED_STATE: [
        'OPEN',
        'OPEN_PENDING',
        'OPEN_ORDERED_LATE'
    ],

    PURCHASE_YELLOW_STATE: [
        'ORDER_PARTIALLY_RECEIVED',
        'OPEN_ORDERED'
    ],

    PURCHASE_STATE_CLOSED_COMPLETE: 'CLOSED_COMPLETE',
    PURCHASE_STATE_CLOSED_RESOLVE: 'CLOSED_COMPLETE',

    PURCHASE_GREEN_STATE: [
        'CLOSED_COMPLETE',
        'CLOSED_COMPLETE_PAID',
        'CLOSED_RESOLVED',
        'CLOSED_RESOLVED_PAID'
    ],

    SINGLE_TASK_TYPES: [
        {
            type: 'BH',
            text: 'Brewing'
        },
        {
            text: 'Fermenting',
            type: 'FV'
        },
        {
            text: 'Packaging',
            type: 'BT'
        }
    ],

    SINGLE_LISTED_TASK_TYPES: [
        {
            type: 'BH',
            text: 'Brewing'
        },
        {
            type: 'FV',
            text: 'Fermenting'
        },
        {
            type: 'BT',
            text: 'Packaging'
        }
    ],

    WHERE_KNOW_US: [
        {source: 'WEB', name: 'Web/Google search'},
        {source: 'PRO_BREWER', name: 'ProBrewer.com'},
        {source: 'SOCIAL_MEDIA', name: 'Social Media'},
        {source: 'COWORKER', name: 'Friend/Other Brewer'},
        {source: 'OTHER', name: 'Other (please explain below)'}
    ],

    // TASK CONSTs
    TYPE_TASK_FERMENTER: 'FERMENTER_TASK',
    TYPE_TASK_PACKAGING: 'PACKAGING_TASK',
    TYPE_TASK_BREWHOUSE: 'BREWHOUSE_TASK',

    // TASK TYPES
    BREW_TASK: 'BREW_TASK',
    FILTRATION_TASK: 'FILTRATION_TASK',
    PACKAGING_TASK: 'PACKAGING_TASK',
    SECONDARY_TASK: 'SECONDARY_TASK',
    SINGLE_TASK: 'SINGLE_TASK',
    TASK_NON_VISIBLE: 'no-icon',
    DEFAULT_TASK_BREWING: 'brewing',
    DEFAULT_TASK_FILTRATION: 'filtration',
    DEFAULT_TASK_PACKAGING: 'packaging',

    FERMENTER_TYPE_TASK: 'fermenter',
    PACKAGING_TYPE_TASK: 'packaging',
    BREWING_TYPE_TASK: 'brewing',

    ROLE_ADMIN: 'ADMIN',
    ROLE_USER: 'USER',

    HISTORY_TYPE_NEW: 'NEW',
    HISTORY_TYPE_CHANGE: 'CHANGE',
    HISTORY_TYPE_DELETE: 'DELETE',

    LANGUAGE_ALLOWED: [
      {display: 'English', value: 'en'},
      {display: 'Spanish', value:'es'},
      {display: 'Portuguese', value:'pt'}
    ],

    STANDARDISE_DECIMAL_SEPARATOR:  '.',

    // TEMPLATE
    ROW_HIGHT: 35,                      // need sync with var: _template.$dashboard-height-row
    HEADER_HIGHT: _isPaidVersion() ? 50 : 100,                  // need sync with: _template.$dashboard-height-header
    COLUMN_HIGHT: 50,
    WIDTH_COMMENT_DASHBOARD: 30,        // need sync with: _template.$chronologyc-bar-with-column-expanded
    WIDTH_COMMENT_BUTTON_DASHBOARD: 70, // need sync with: _template.$chronologyc-bar-with-column

    // dashboard behavior
    DEFAULT_MONTH_BEFORE: 0,
    DEFAULT_DAYS_BEFORE: 21,
    DEFAULT_MONTH_AFTER: 2,
    DEFAULT_DAYS_AFTER: 0,
    DAYS_BACKWARD_FORWARD: 20,

    DEFAULT_LANGUAGE: 'en',
    PREFERRED_LANGUAGE: navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || 'en',

    // APP Version key
    APP_VERSION_KEY: 'APP_VERSION_KEY',

    // Decimals
    DEFAULT_AMOUNT_DECIMAL: 2,

    // Inventory status icon

    // GREEN WITH WHITE CHECK
    INVENTORY_ALL_DISCOUNTED_AND_CONFIRMED: 'all_discounted_confirmed',

    // GREEN
    INVENTORY_SOME_CONFIRMED_AND_SOME_UNCONFIRMED: 'some_confirmed_some_unconfirmed',

    // GREEN
    INVENTORY_IS_ENOUGH_INVENTORY: 'is_enough_inventory',

    // GREEN
    INVENTORY_SOME_WAS_UNCONFIRMED_ALREADY_DISCOUNTED: 'some_was_unconfirmed_already_discounted',

    // YELLOW CIRCLE
    INVENTORY_MISSING_ITEMS_BUT_PURCHASE_IN_COMING: 'purchase_in_coming',

    // RED CIRCLE
    INVENTORY_MISSING_ITEMS: 'missing-items',

    // RED CIRCLE WITH WHITE ADMIRATION
    INVENTORY_SOME_PRODUCT_NON_CONFIRMED_OUT_SCOPE: 'some-product-non-confirmed-out-scope',

    // The maximiun days before today that will be take care to calculate
    // the reservation of the scope inventory (non-confirmed product in orders in the past)
    INVENTORY_MAX_PAST_DAYS_SCOPE: 10,

    // Errors code
    ERROR_CODE_APPLICANT_ALREADY_EXIST: '0001',
    ERROR_CODE_EMAIL_ALREADY_EXIST: '0002',
    ERROR_CODE_USERNAME_ALREADY_EXIST: '0003',
    ERROR_CODE_USERNAME_GUEST_ALREADY_EXIST: '0004',
    ERROR_CODE_ADMIN_USERNAME_SAME_GUEST_USERNAME: '0005',
    ERROR_CODE_USERNAME_DO_NOT_EXIST: '0006',
    ERROR_CODE_TANK_VOLUME_TOO_SMALL: '0007',
    ERROR_CODE_VENDOR_WITHOUT_EMAIL: '0008',
    ERROR_CODE_SALE_NOT_ENOUGH_ITEM: '0009',
    ERROR_CODE_SALE_WITHOUT_CONTACT_EMAIL: '0010',

    // Order operation
    ORDER_OPERATION_NEW: 'NEW_ORDER',
    ORDER_OPERATION_CHANGE: 'CHANGE_ORDER',
    ORDER_OPERATION_DELETE: 'DELETE_ORDER',

    // Brewing Note operation
    NOTE_BREWING_OPERATION_NEW: 'NEW_BREWING_NOTE',
    NOTE_BREWING_OPERATION_CHANGE: 'CHANGE_BREWING_NOTE',
    NOTE_BREWING_OPERATION_DELETE: 'DELETE_BREWING_NOTE',

    NOTE_TYPE_PACKAGING: 'NOTE_TYPE_PACKAGING',
    NOTE_TYPE_BREWING: 'NOTE_TYPE_BREWING',

    // Tabs
    INDEX_FIRST_TAB: 0,
    INDEX_SECOND_TAB: 1,

    // DECIMAL FORMATTER
    ITEM_AMOUNT_DIGITS_DECIMALS: 4,

    INDEX_TABS_DIALOG_ORDER: {
        'BH': 1,
        'FV': 2,
        'BT': 3
    },
    
    getReportByMapping(t){
        return {
            ['Total']: t('total'),
            ['Month']: t('month'),
            ['Week']: t('week'),
            ['Day']: t('day')
        };
    },

    // Packaging Note operation
    NOTE_PACKAGING_OPERATION_NEW: 'NEW_PACKAGING_NOTE',
    NOTE_PACKAGING_OPERATION_CHANGE: 'CHANGE_PACKAGING_NOTE',
    NOTE_PACKAGING_OPERATION_DELETE: 'DELETE_PACKAGING_NOTE',

    DRAFT_ORDER_PREFIX: 'DRAFT_ORDER_ID_',
    MAX_DRAFT_OPERATION: 35,
    NOTE_PREFIX: 'NOTE_ID_',
    DATE_FORMAT: 'YYYY-MM-DD',
    DATE_FORMAT_DISPLAY: 'MM/DD/YYYY',
    DATE_FORMAT_DISPLAY_COMBO: 'MMMM, ddd DD',
    DATE_FORMAT_DISPLAY_COMBO_DAY: 'ddd, DD',
    DATE_FORMAT_SHORT: 'MM-DD',
    DATE_FORMAT_LONG: 'YYYY-MM-DDThh:mm:ssZZ',

    // APP Modules
    APP_MODULE_ADMIN_ICON: 'ADMIN_ICON',
    APP_MODULE_ADMIN_ITEM: 'ADMIN_ITEM',
    APP_MODULE_ADMIN_PRODUCT: 'ADMIN_PRODUCT',
    APP_MODULE_ADMIN_PRODUCT_ICON: 'ADMIN_PRODUCT_ICON',
    APP_MODULE_ADMIN_PRODUCT_ITEM: 'ADMIN_PRODUCT_ITEM',
    APP_MODULE_ADMIN_TANK: 'ADMIN_TANK',
    APP_MODULE_ADMIN_BEER_STYLE: 'ADMIN_BEER_STYLE',
    APP_MODULE_ADMIN_BEER_STYLE_CONFIGURATION: 'ADMIN_BEER_STYLE_CONFIGURATION',
    APP_MODULE_ADMIN_LOCATION: 'ADMIN_LOCATION',
    APP_MODULE_ADMIN_LOCATION_ITEM: 'ADMIN_LOCATION_ITEM',
    APP_MODULE_ADMIN_VENDORS: 'ADMIN_VENDORS',
    APP_MODULE_ADMIN_VENDORS_CONTACTS: 'ADMIN_VENDORS_CONTACTS',
    APP_MODULE_ADMIN_VENDORS_ADDRESS: 'ADMIN_VENDORS_ADDRESS',
    APP_MODULE_ADMIN_VENDORS_ITEM: 'ADMIN_VENDORS_ITEM',
    APP_MODULE_DASHBOARD_ORDERS: 'DASHBOARD_ORDERS',

    //Order dates defaults
    DEFAULT_FERMENTER_DAYS_AFTER_BREW_DAY: 13,
    DEFAULT_PACKAGING_DAYS_AFTER_BREW_DAY: 14,

    // KEYWORD EVENT
    ENTER_KEY_CODE: 13,
    P_KEY_CODE: 80,

    REGEX_NAME_DEFAULT: /^[A-Za-z\d\&\-_ñüéáíóúàèùâêîôûäëçãõÆØÅæøäЗахарченкоАлексей\s]+$/,
    REGEX_NAME_SIGNUP: /^[A-Za-z0-9\-_. ]+$/,
    REGEX_NAME_RELAXED: /^[A-Za-z\d\&\-_/ñüéáíóúàèùâêîôûäëçãõÆØÅæøäЗахарченкоАлексей().°@,+\s]+$/,
    REGEX_EMAIL: /^(([^ñüéáíóúàèùâêîôûäëçãõÆØÅæøäЗахарченкоАлексей<>()\[\]\\.,;:\s@"]+(\.[^ñüéáíóúàèùâêîôûäëçãõÆØÅæøäЗахарченкоАлексей<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,

    // Users Roles
    USERS_ROLES:['Administrator', 'Guest'],
    getUserRolesMapping(t) {
        return {
            ['Administrator']: t('administrator'),
            ['Guest']: t('guest')
        };
    },
    getUserRoles(t) {
        return [
            {role: 'Administrator', displayText: t('administrator')},
            {role: 'Guest', displayText: t('guest')}
        ];
    },

    GO_PRO_URL: 'https://www.brewplanner.com/gopro',

    TIME_WAIT_MODAL_EXPAND: 50,
    TIME_WAIT_MODAL_REFRESH_EXPAND: 70 // Always this value should be longer than TIME_WAIT_MODAL_EXPAND
};



/** WEBPACK FOOTER **
 ** ./src/constants/AppConstants.js
 **/